import { render } from "./AddProduct.vue?vue&type=template&id=34c1047a&scoped=true&ts=true"
import script from "./AddProduct.vue?vue&type=script&lang=ts"
export * from "./AddProduct.vue?vue&type=script&lang=ts"

import "./AddProduct.vue?vue&type=style&index=0&id=34c1047a&lang=css"
import "./AddProduct.vue?vue&type=style&index=1&id=34c1047a&lang=scss&scoped=true"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c1047a"]])

export default __exports__